// --- 交易管理 --- //

export default [
  {
    name: 'tradeInquire',
    path: '/supplySystem/:supplyId/tradeManagement/tradeInquire',
    meta: { title: '交易查询' },
    component: require('business/supplySystem/tradeManagement/tradeInquire/list.vue').default
  },
  {
    name: 'chargeBackManagement',
    path: '/supplySystem/:supplyId/tradeManagement/chargeBackManagement',
    meta: { title: '退单管理' },
    component: require('business/supplySystem/tradeManagement/chargeBackManagement/list.vue').default
  },
  {
    name: 'tradeStatement',
    path: '/supplySystem/:supplyId/tradeManagement/tradeStatement',
    meta: { title: '交易报表' },
    component: require('business/supplySystem/tradeManagement/tradeStatement/list.vue').default
  },
  {
    name: 'tradeInquireDetail',
    path: '/supplySystem/:supplyId/tradeManagement/tradeInquire/tradeInquireDetail',
    meta: { title: '交易报表详情' },
    component: require('business/supplySystem/tradeManagement/tradeInquire/detail.vue').default
  }
]
